<template>
  <div class="faf-sanoma-container polyglottTypewriter edit-mode">
    
    <div class="sanoma-header">
      <div class="sanoma-id">
        SANOMA n:o <span class="handwritten-id">{{ report_info.mission_id || '1639' }}</span>
      </div>
    
      <div class="header-grid">
        <div class="grid-box col-3">
          <span class="tiny-label">Viestin laatu:</span>
          <div class="grid-content">LES 0115 8541</div>
        </div>
        <div class="grid-box col-6">
          <span class="tiny-label">Aika/Pvm:</span>
          <div class="grid-content">{{ decodeHTML(missionById(report_info.mission_id).hist_date).split(' ')[0] }}</div>
        </div>
        <div class="grid-box col-3">
          <span class="tiny-label">Kello:</span>
          <div class="grid-content">{{ decodeHTML(missionById(report_info.mission_id).hist_date).split(' ')[1] }}</div>
        </div>
      </div>

      <div class="header-grid no-top">
        <div class="grid-box col-12">
          <span class="tiny-label">Lähettäjä:</span>
          <div class="grid-content">
            {{ decodeHTML(report_info.rank_name) }} {{ decodeHTML(report_info.last_name) }} / 
            <select v-model="report_unit" class="sanoma-edit-input">
               <option v-for="d_unit in unitsByFaction(7)" :value="d_unit.depl_unit_id">
                {{ d_unit.hist_unit_name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="sanoma-body">
      <div class="typed-line">
        == {{ reportUnit.hist_unit_code }}
      </div>

      <div class="typed-line">
        KONE: 
        <select v-model="report_aircraft" class="sanoma-edit-input">
          <option :value="null" disabled>Select aircraft</option>
          <option v-for="aircraft in assetByFactionControllable(7, 1)" :value="aircraft.id">
            {{ aircraft.name }}
          </option>
        </select>
        <input v-model="report_markings" placeholder="Markings" class="sanoma-edit-input">
      </div>

      <div class="typed-line">
        OHJAAJA: {{ decodeHTML(report_info.rank_name) }} {{ decodeHTML(report_info.first_name) }} '{{ report_info.callsign }}' {{ decodeHTML(report_info.last_name) }}
      </div>

      <div class="typed-line">
        TUKIKOHTA: 
        <input v-model="report_aerodrome" placeholder="Airfield" class="sanoma-edit-input">
      </div>

      <div class="separator-line">--------------------------------------------------</div>

      <div class="mission-content">
        <div class="typed-line label-line">TEHTÄVÄN SUORITUS:</div>
        <textarea
          v-model="report_synopsis"
          placeholder="Synopsis (optional)"
          class="sanoma-edit-textarea"
        ></textarea>
      </div>
    </div>

    <div class="sanoma-footer clearfix">
      <div class="float-right signature-block">
        <div class="signature-text">
          == {{ decodeHTML(report_info.rank_name) }} {{ decodeHTML(report_info.last_name) }} ==
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import stringConv from "../../resource/stringConverter"
  import statConv from "../../resource/statusConverter"
  import { mapState, mapGetters } from "vuex"

  export default {
    name: "EditReportFAF",
    components: {

    },
    mixins: [
      stringConv,
      statConv
    ],
    props: {
      first_name: {
        type: String,
        default: null
      },
      last_name: {
        type: String,
        default: null
      },
      callsign: {
        type: String,
        default: null
      },
      rank_name: {
        type: String,
        default: null
      },
    },
    mounted () {

    },
    data () {
      return {
      }
    },
    computed: {

      report_unit: {
        get () {
          return this.report_info.depl_unit_id;
        },
        set (value) {
          this.$store.commit('missionStore/updateReportValue',
            {
              array_name: "report",
              update_column_name: "depl_unit_id",
              update_column_value: value
            });
        }
      },

      report_aerodrome: {
        get () {
          return this.report_info.base;
        },
        set (value) {
          this.$store.commit('missionStore/updateReportValue',
            {
              array_name: "report",
              update_column_name: "base",
              update_column_value: value
            });
        }
      },

      report_aircraft: {
        get () {
          return this.report_info.asset_id;
        },
        set (value) {
          this.$store.commit('missionStore/updateReportValue',
            {
              array_name: "report",
              update_column_name: "asset_id",
              update_column_value: value
            });
        }
      },

      report_markings: {
        get () {
          return this.report_info.markings;
        },
        set (value) {
          this.$store.commit('missionStore/updateReportValue',
            {
              array_name: "report",
              update_column_name: "markings",
              update_column_value: value
            });
        }
      },

      report_synopsis: {
        get () {
          return this.report_info.synopsis;
        },
        set (value) {
          this.$store.commit('missionStore/updateReportValue',
            {
              array_name: "report",
              update_column_name: "synopsis",
              update_column_value: value
            });
        }
      },

      ...mapState("missionStore", {
        report_info: state => state.report,
        report_details: state => state.report_details,
        aerial_claims: state => state.aerial_claims,
        ground_claims: state => state.ground_claims
      }),

      ...mapGetters("missionStore", [
        "reportUnit",
        "unitsByFaction",
        "assetByFactionControllable",
        "missionById"
      ])
    },
    methods: {

      addAerialClaim: function () {

        this.$store.commit('missionStore/addAerialClaim',
          {
            report_id: this.report_info.report_id,
            asset_id: null,
            claim_time: null,
            place: null,
            group_claim: 0,
            confirmed: 0,
            witness_id: null
          });
      },

      addGroundClaim: function () {

        this.$store.commit('missionStore/addGroundClaim',
          {
            report_id: this.report_info.report_id,
            asset_id: null,
            amount: 1,
            description: null
          });
      }
    }
  }
</script>

<style scoped>

div {
  margin: 5px 0;
}

.textarea-style{
  width: 98%;
  height: 15em;
  font-family: "TrueTypewriter PolyglOTT";
}


.biggerCenter {
  font-size: x-large;
  text-align: center
}

.bigRight {
  float: right;
  font-size: large;
  margin-right: 8%;
}
.faf-sanoma-container {
  width: 100%;
  color: inherit;
  font-family: 'Courier New', Courier, monospace;
}

/* Header Grid Styling */
.sanoma-header {
  margin-bottom: 30px;
}

.sanoma-id {
  text-align: right;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 1.2rem;
}

.handwritten-id {
  font-family: 'Brush Script MT', cursive; /* To mimic the handwritten number in the scan */
  font-size: 1.5rem;
  padding-left: 10px;
}

.header-grid {
  display: flex;
  border: 1px solid currentColor;
}

.no-top { border-top: none; }

.grid-box {
  padding: 4px 8px;
  border-right: 1px solid currentColor;
  min-height: 40px;
}

.grid-box:last-child { border-right: none; }

.col-3 { width: 25%; }
.col-6 { width: 50%; }
.col-12 { width: 100%; }

.tiny-label {
  display: block;
  font-size: 0.65rem;
  text-transform: uppercase;
}

.grid-content {
  font-weight: bold;
  font-size: 1rem;
}

/* Body Styling */
.sanoma-body {
  line-height: 1.6;
}

.typed-line {
  margin-bottom: 8px;
  text-transform: uppercase; /* Most Finnish reports were typed in caps */
  letter-spacing: 1px;
}

.label-line {
  font-weight: bold;
  text-decoration: underline;
}

.mission-text {
  padding-left: 10px;
  display: block;
  margin-top: 10px;
}

.separator-line {
  margin: 20px 0;
  opacity: 0.5;
}

/* Signature */
.signature-block {
  margin-top: 40px;
  text-align: center;
}

.signature-text {
  font-weight: bold;
  border-bottom: 1px solid currentColor;
  margin-bottom: 10px;
  padding: 0 20px;
}


</style>




// WEBPACK FOOTER //
// src/components/campaign/EditReportFAF.vue